module.exports = __webpack_public_path__ + "location_pin.e9b51f365d765af7e9f19d636b710b83.svg";